<template>
  <div class="cial-main">
    <!-- <van-nav-bar
          :title="$route.meta.title"
          left-text="返回"
          @click-left="$router.back()"
          left-arrow
          :fixed="true"
        /> -->
    <div class="Item-content" v-for="(item, index) in optionArr" :key="index">
      <van-dropdown-menu :overlay="false" active-color="#1989fa">
        <van-dropdown-item
          v-model="value[index]"
          :options="item"
          :data-index="index"
          @change="handleChangeMenu($event, index)"
        />
      </van-dropdown-menu>
    </div>
    <div class="select-name">
      {{ allName }}
    </div>
    <div
      class="btn"
      :class="[levelNo ? 'active' : '']"
      @click="handleSeleteAdress"
    >
      {{ $t("addressBtn") }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      levelNo: "",
      value: ["-1"],
      optionArr: [],
      allName: "",
      fieldValue: "",
      language: "CN",
    };
  },
  mounted() {
    this.language = localStorage.getItem("language");
    this.getAdressList(0);
  },
  methods: {
    getAdressList(id, levelNo) {
      let option1 = [
        {
          text:
            id == 0
              ? this.$t("addressTip1")
              : id == 1
              ? this.$t("addressTip2")
              : id == 2
              ? this.$t("addressTip2")
              : id == 3
              ? this.$t("addressTip2")
              : this.$t("addressTip2"),
          value: "-1",
          allName: "",
          parentId: "",
        },
      ];
      let shopId = localStorage.getItem("shopId");
      this.$logina
        .post(
          `/api/wxapp/multiLevelCategory/query?shopId=${shopId}&levelNo=${this.levelNo}`
        )
        .then((res) => {
          let resData = res.data;
          resData.data.map((item) => {
            let option = {
              text: "",
              value: "",
              allName: "",
              parentId: "",
            };
            option.text = item.levelName;
            option.value = item.levelNo;
            option.allName = item.allName;
            option.parentId = item.parentId;
            option1.push(option);
          });
          this.setCurrentData(id, option1, levelNo);
        });
    },
    setCurrentData(index, data, levelNo) {
      let optionArr = this.optionArr;
      optionArr.splice(index, optionArr.length);
      if (data.length > 1) {
        optionArr[index] = data;
      }
      this.optionArr = optionArr;
      this.levelNo = data.length <= 1 && levelNo != "-1" ? levelNo : null;
    },
    handleChangeMenu(e, index) {
      this.levelNo = e;
      let indexs = index + 1;
      let currentSelect = {
        allName: "错误",
      };
      this.optionArr.map((item, index) => {
        let _currentSelect = item.find((item) => item.value == this.levelNo);
        if (_currentSelect) {
          currentSelect = _currentSelect;
        }
        this.value.push("-1");
      });
      console.log(this.optionArr, "lll");
      this.allName = currentSelect.allName;
      this.getAdressList(indexs, this.levelNo);
    },
    handleSeleteAdress() {
      if (!this.levelNo) {
        return this.$toast("请选择完整位置");
      }
      let adress = {
        allName: this.allName,
        levelNo: this.levelNo,
      };
      localStorage.setItem("global-address", JSON.stringify(adress));
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.cial-main {
  width: 100%;
  height: 100vh;
  background: #f8f8f8;
  padding: 16px;
  box-sizing: border-box;
  overflow: auto;
  .Item-content {
    border-bottom: 1px solid rgb(238, 236, 236);
  }
  .Item-content:nth-last-child(1) {
    border: none;
  }
  .select-name {
    margin: 4% 0;
    padding: 10px;
    text-align: center;
    background-color: white;
    font-size: 14px;
  }
  .btn {
    width: 100%;
    font-size: 16px;
    padding: 10px;
    background-color: #1989fa;
    color: white;
    text-align: center;
    position: fixed;
    opacity: 0.3;
    border-radius: 5px;
    bottom: 0;
    left: 0;
  }
  .active {
    opacity: 1;
  }
}
</style>

<style>
.Item-content .van-dropdown-menu__title {
  max-width: 90% !important;
}
</style>
